import { defineStore } from 'pinia'
import { computed } from 'vue'
import type { ExperienceFlowStoreType } from '@/services/experienceFlows/types'
import { buildExperienceFlowAstrazenecaParams } from '@gh/common/models'

export const useExperienceFlowAstrazenecaStore = defineStore<
  'experienceFlow_Astrazeneca',
  ExperienceFlowStoreType
>('experienceFlow_Astrazeneca', () => {
  const store = computed(() => buildExperienceFlowAstrazenecaParams())

  return {
    empty: computed(() => store.value.empty),
    sponsorScreenAfterClassSelection: computed(() => store.value.sponsorScreenAfterClassSelection),
  }
})
